import {lazyLoadView} from "@utils/views";

export default {
    path: '/tourist',
    name: 'tourist',
    component: () => lazyLoadView(import('@views/tourist.vue')),
    meta: {
        authRequired: false,
        beforeResolve(routeTo, routeFrom, next) {
            return next();
        },
    }
}
